import { render, staticRenderFns } from "./PickupInfo.vue?vue&type=template&id=af254156"
import script from "./PickupInfo.vue?vue&type=script&lang=ts"
export * from "./PickupInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports